import { ScreenOrientation } from '@capacitor/screen-orientation';

/** The usual "tablet" line: a device whose short side is 600 CSS px or more. */
export const TABLET_MIN_SIDE = 600;

/**
 * A phone is a device whose short side is under 600 CSS px. Phones turned
 * sideways are wider than the 768px desktop breakpoint, so they used to get the
 * desktop layout; they stay upright instead. Tablets rotate freely.
 */
export function isPhone(screenWidth: number, screenHeight: number): boolean {
  return Math.min(screenWidth, screenHeight) < TABLET_MIN_SIDE;
}

/** Native only: keep phones in portrait. Never throws; a failed lock just leaves rotation on. */
export async function lockPhonePortrait(): Promise<void> {
  try {
    if (isPhone(window.screen.width, window.screen.height)) {
      await ScreenOrientation.lock({ orientation: 'portrait' });
    }
  } catch (err) {
    console.warn('orientation lock failed', err);
  }
}
